import {
  PADDING,
  PanelCarouselCircleTabs,
  PanelCarouselContainerRow,
  PanelCarouselRow,
} from 'src/rebrand/Homepage/components/shared/PanelCarouselStyles';
import { useCarousel } from 'src/shared/design-system/DishFirst/Carousel';
import { HandHoldingBowlHeart } from 'src/shared/design-system/Icon';
import { useMarketSegment } from 'src/shared/hooks/useMarketSegment';
import { useRefState } from 'src/shared/hooks/useRefState';
import { useScreenContext } from 'web-common/src/shared/context/ScreenContext/hook';
import { HeaderBlock } from '../HeaderBlock/HeaderBlock';
import { DesktopContainer, DishRow, TopRow } from './styles';
import { TastesLikeHomePanel } from './TastesLikeHomePanel';
import { getTastesLikeHomeContent } from './utils';

export const TastesLikeHome = () => {
  const [ref, setRef] = useRefState<HTMLDivElement>();
  const { marketSegment } = useMarketSegment();
  const tastesLikeHomeContent = getTastesLikeHomeContent(marketSegment);
  const { scrollTo, scrolledElement } = useCarousel({
    ref,
    content: tastesLikeHomeContent,
    padding: PADDING,
    onScreenThreshold: 200,
  });
  const { isLargeScreen } = useScreenContext();

  if (!isLargeScreen) {
    return (
      <div className={`flex w-full flex-col items-center font-sans`}>
        <TopRow>
          <HeaderBlock icon={<HandHoldingBowlHeart />} text={'Tastes like home'} />
          <p className='mb-0 mt-4 text-base text-neutral-600'>
            Enjoy the delicious and authentic Indian dishes in your neighborhood, made by local shefs.
          </p>
        </TopRow>
        <PanelCarouselContainerRow>
          <PanelCarouselRow ref={setRef}>
            {tastesLikeHomeContent.map((content, i) => (
              <TastesLikeHomePanel key={i} content={content} onClick={() => scrollTo(i)} />
            ))}
          </PanelCarouselRow>
        </PanelCarouselContainerRow>
        <PanelCarouselCircleTabs className='z-10 mt-10'>
          {tastesLikeHomeContent.map((content, i) => (
            <span
              key={content.shefName}
              onClick={() => scrollTo(i)}
              className={scrolledElement === i ? 'text-neutral-500' : 'text-neutral-200'}>
              <i className='fa-solid fa-circle' />
            </span>
          ))}
        </PanelCarouselCircleTabs>
      </div>
    );
  }

  return (
    <DesktopContainer>
      <TopRow>
        <HeaderBlock icon={<HandHoldingBowlHeart />} text={'Tastes like home'} />
        <p className='mb-0 mt-4 text-base text-neutral-600'>
          Enjoy the delicious and authentic Indian dishes in your neighborhood, made by local shefs.
        </p>
      </TopRow>
      <DishRow>
        {tastesLikeHomeContent.map((content, i) => (
          <TastesLikeHomePanel key={content.shefName} content={content} onClick={() => scrollTo(i)} />
        ))}
      </DishRow>
    </DesktopContainer>
  );
};
